const usd = new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" });

/** Formats an API decimal string ("1234.5") as USD. */
export function formatUSD(amount: string | number | undefined | null): string {
  if (amount === undefined || amount === null || amount === "") return "—";
  const n = typeof amount === "number" ? amount : Number(amount);
  return Number.isFinite(n) ? usd.format(n) : String(amount);
}

export function formatDate(iso: string | undefined | null, withTime = false): string {
  if (!iso) return "—";
  const d = new Date(iso);
  return d.toLocaleString("en-US", withTime ? { dateStyle: "medium", timeStyle: "short" } : { dateStyle: "medium" });
}

export function humanize(s: string | undefined | null): string {
  if (!s) return "";
  const t = s.replace(/[_.]/g, " ");
  return t.charAt(0).toUpperCase() + t.slice(1);
}

export function shortId(id: string | undefined | null): string {
  return id ? id.slice(-8) : "";
}
